import Vue from 'vue';
import draftDB from '@mobile/db/drafts';

export default {
    namespaced: true,

    state: getDefaultState(),

    getters: {
        all: (state) => state.drafts,
        count: (state) => state.drafts.length,
    },

    actions: {
    	async loadFromDB({ state, rootGetters }) {
    		if (rootGetters['authentication/user']) {
                const drafts = await draftDB.getAllForUser(rootGetters['authentication/user'].id);
        		state.drafts = drafts;
            }
    	},
        async delete({ dispatch }, draftId) {
            await draftDB.delete(draftId);
            await dispatch('loadFromDB');
        },
    },

    mutations: {

        reset(state) {
            Object.assign(state, getDefaultState());
        },

    },

};

function getDefaultState() {
    return {
        drafts: [],
    };
}
